module.exports = __webpack_public_path__ + "img/search_image.48e7f199.png";